import type { Module } from 'vuex';
import { TranslateLanguagePage } from '@/types/TranslateLanguagePage';
import {RootState} from "@/store";

export interface TranslateLanguagePagesState {
  translateLanguagePages: TranslateLanguagePage[];
}

const translateLanguagePagesModule: Module<TranslateLanguagePagesState, RootState> = {
  namespaced: true,

  state: (): TranslateLanguagePagesState => ({
    translateLanguagePages: [],
  }),

  getters: {
    getById: (state) => (idTranslateLanguagePage: number): TranslateLanguagePage | undefined => {
      return state.translateLanguagePages.find(translateLanguagePage => translateLanguagePage.idTranslateLanguagePage === idTranslateLanguagePage);
    },
    getByLanguagePage: (state) => (idLanguagePage: number): TranslateLanguagePage[] => {
      return state.translateLanguagePages.filter(translateLanguagePage => translateLanguagePage.idLanguagePage === idLanguagePage);
    },
  },

  mutations: {
    setTranslateLanguagePages(
      state,
      payload: { translateLanguagePages: Record<number, any> }
    ) {
      state.translateLanguagePages = Object
        .values(payload.translateLanguagePages)
        .map(raw => TranslateLanguagePage.fromRaw(raw));
    },

    setTranslateLanguagePageCreate(
      state,
      payload: {
        idTranslateLanguagePage: number;
        idLanguagePage: number;
        idLanguage: number;
        title: string;
        breadCrumb: string;
      }
    ) {
      const raw = {
        idTranslateLanguagePage: payload.idTranslateLanguagePage,
        idLanguagePage: payload.idLanguagePage,
        idLanguage: payload.idLanguage,
        title: payload.title,
        breadCrumb: payload.breadCrumb,
        locked: false,
      };
      state.translateLanguagePages.push(TranslateLanguagePage.fromRaw(raw));
    },

    setTranslateLanguagePageUpdate(
      state,
      payload: {
        idTranslateLanguagePage: number;
        title?: string;
        breadCrumb?: string;
      }
    ) {
      const translateLanguagePage = state.translateLanguagePages.find(translateLanguagePage => translateLanguagePage.idTranslateLanguagePage === payload.idTranslateLanguagePage);
      if (!translateLanguagePage) return;
      if (payload.title !== undefined) translateLanguagePage.title = payload.title;
      if (payload.breadCrumb !== undefined) translateLanguagePage.breadCrumb = payload.breadCrumb;
    },

    setTranslateLanguagePageDelete(
      state,
      payload: { idTranslateLanguagePage: number }
    ) {
      state.translateLanguagePages = state.translateLanguagePages.filter(
        translateLanguagePage => translateLanguagePage.idTranslateLanguagePage !== payload.idTranslateLanguagePage
      );
    },

    setTranslateLanguagePageLock(
      state,
      payload: { idTranslateLanguagePage: number }
    ) {
      const translateLanguagePage = state.translateLanguagePages.find(translateLanguagePage => translateLanguagePage.idTranslateLanguagePage === payload.idTranslateLanguagePage);
      if (translateLanguagePage) translateLanguagePage.locked = true;
    },

    setTranslateLanguagePageUnlock(
      state,
      payload: { idTranslateLanguagePage: number }
    ) {
      const translateLanguagePage = state.translateLanguagePages.find(translateLanguagePage => translateLanguagePage.idTranslateLanguagePage === payload.idTranslateLanguagePage);
      if (translateLanguagePage) translateLanguagePage.locked = false;
    },
  },

  actions: {
    wsSetTranslateLanguagePages({ commit }, payload) {
      commit('setTranslateLanguagePages', payload);
    },
    wsTranslateLanguagePageCreate({ commit }, payload) {
      commit('setTranslateLanguagePageCreate', payload);
    },
    wsTranslateLanguagePageUpdate({ commit }, payload) {
      commit('setTranslateLanguagePageUpdate', payload);
    },
    wsTranslateLanguagePageDelete({ commit }, payload) {
      commit('setTranslateLanguagePageDelete', payload);
    },
    wsTranslateLanguagePageLock({ commit }, payload) {
      commit('setTranslateLanguagePageLock', payload);
    },
    wsTranslateLanguagePageUnlock({ commit }, payload) {
      commit('setTranslateLanguagePageUnlock', payload);
    },
  },
};

export default translateLanguagePagesModule;
